import { inject, Injectable } from '@angular/core';
import { ToastButton, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMessage } from '../helpers/formUtils.helper';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { AbstractApi } from './abstract.api';

export interface User {
  id?: string;
  email?: string;
  name?: string;
  roles?: string[];
  beta?: boolean;

  scalewayId?: string;
  scalewayKey?: string;
  scalewayCert?: string;
  scalewayP12?: string;

  cgu?: boolean;

  emailValidationAt?: string;
  isCompanyUser?: boolean;

  lang?: string;
  theme?: string;
  tempUnit?: string;

  modeDemoEnabled?: boolean;
  modeDemoData?: string;
  notificationEnabled?: boolean;

  plainPassword?: {
    first?: string;
    second?: string;
  };

  userCompanies?: any;
}

export interface UserDevice {
  id?: string;
  deviceToken?: string;
  deviceType?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfilApi extends AbstractApi {
  public me(): Promise<User> {
    return firstValueFrom(this.http.get<User>(`${this.backend}/api/v1/me`));
  }

  public patchMe(user: User): Promise<User> {
    return firstValueFrom(
      this.http.patch<User>(`${this.backend}/api/v1/me`, user),
    );
  }

  public deleteMe(): Promise<User> {
    return firstValueFrom(this.http.delete<User>(`${this.backend}/api/v1/me`));
  }
}
